import React from 'react'
import Header from '../../layouts/Header'
import Footer from '../../layouts/Footer'
import ReactNativeHero from '../../layouts/Technologie/ReactNativepage/ReactNativeHero'
import WhyChooseReactNative from '../../layouts/Technologie/ReactNativepage/WhyChooseReactNative'
import BenefitsReactNative from '../../layouts/Technologie/ReactNativepage/BenefitsReactNative'
import ReactNativeFeatures from '../../layouts/Technologie/ReactNativepage/ReactNativeFeatures'
import FinalCTA from '../../layouts/FinalCTA'

const ReactNativepage = () => {
    return (
        <>
            <Header />
            <ReactNativeHero />
            <BenefitsReactNative />
            <WhyChooseReactNative />
            <ReactNativeFeatures />
            <FinalCTA/>
            <Footer />
        </>
    )
}

export default ReactNativepage